import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { LOGO_LG } from '@assets';
import { useNavigate } from 'react-router';
import { PUBLIC_ROUTE } from '@router/route.constants';
import { LIMITS } from '@constants';
import { useSelector } from 'react-redux';

const Container = styled.div`
width: 100%;
height: 100vh;
display: flex;
align-items: center;
justify-content: center;
background: linear-gradient(180deg, rgba(74,14,68,1) 15%, rgba(30,23,47,1) 60%);
`;

const Image = styled.img.attrs({
    alt: 'logo',
    src: LOGO_LG,
})`
width: 55%;
height: auto;
object-fit: contain;
`;

const Splash = () => {
    const navigate = useNavigate();
    const { splash_ads_active } = useSelector(state => state.app.settings);
    let timer = useRef();

    useEffect(() => {
        timer.current = setTimeout(() => {
            goToNextScreen(splash_ads_active);
        }, LIMITS.SPLASH_SCREEN_TIMEOUT * 1000);

        return () => {
            clearTimeout(timer.current);
        }
        // eslint-disable-next-line
    }, [splash_ads_active]);

    const goToNextScreen = (splash_ads_active) => {
        if (splash_ads_active) {
            navigate(PUBLIC_ROUTE.ONBOARDING);
        }
        else {
            navigate(PUBLIC_ROUTE.LOGIN);
        }
    }

    return (
        <Container>
            <Image />
        </Container>
    );
}

export default Splash;